<template>
  <div>
    <Modal
      ref="modal"
      title="Activate teammate"
      body="Are you sure you want to activate this teammate? Activating a teammate adds them back to your team."
      action="Activate"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleActivate"
    />
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import { toast } from 'vue-sonner';

export default {
  components: {
    Modal,
  },
  data() {
    return {};
  },
  methods: {
    handleActivate() {
      const self = this;
      fetch(`/api/teammates/${self.$route.params.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: JSON.stringify({
          teammate_status: 'Active',
        }),
      })
        .then(response => response.json())
        .then(async data => {
          if (data.status != 'error') {
            self.$emit('handleContactActivate');
            self.$refs.modal.success();
            await self.$router.push('/teammates?sort=created&order=desc&status=Active');
            toast.success('Teammate activated', {
              action: { label: 'Dismiss' },
              description: 'Your candidate was successfully activated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$refs.modal.error();
            toast.error('Teammate activate error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
    handleCancel() {
      this.$emit('handleContactActivateCancel');
    },
  },
};
</script>
